// extracted by mini-css-extract-plugin
export var dot = "_qi-2";
export var wave = "_qi-0";
export var waveSmall = "_qi-1";